import React, { useEffect } from "react";

const pdfUrl = new URL(
  "../../assets/pdf/dépliant 4x4 vert technique nov 2016.pdf",
  import.meta.url,
).href;

const TechBrochure: React.FC = () => {
  useEffect(() => {
    let meta = document.querySelector(
      'meta[name="robots"]',
    ) as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    const previous = meta.getAttribute("content");
    meta.setAttribute("content", "noindex, nofollow");
    // Try to open in a new tab (may be blocked); fallback to same-tab redirect
    const win = window.open(pdfUrl, "_blank", "noopener,noreferrer");
    if (!win) {
      window.location.replace(pdfUrl);
    }
    return () => {
      if (previous) meta!.setAttribute("content", previous);
      else meta!.remove();
    };
  }, []);

  return (
    <section
      style={{
        maxWidth: 800,
        margin: "40px auto",
        padding: "0 16px",
        textAlign: "center",
      }}
    >
      <p>
        Redirection vers le PDF… Si rien ne se passe,{" "}
        <a href={pdfUrl}>cliquez ici</a>.
      </p>
    </section>
  );
};

export default TechBrochure;
